// Routes of the Automation screens. The detail page takes { id, automation?,
// color? } and the device page { data: device } as location.state. New takes
// the app's AutomationCreate params, { type?, applianceId?, event? } to start
// from a device, and Edit { automation }.
export const AUTOMATION_PATHS = Object.freeze({
  HOME: "/automations",
  DETAIL: "/automation",
  HISTORY: "/automations/history",
  DEVICE: "/device-automations",
  CREATE: "/automation/new",
  EDIT: "/automation/edit",
});
